import React from "react";
import { Box, Typography, useTheme, alpha } from "@mui/material";

const CountdownTimer = ({ seconds, message }) => {
  const theme = useTheme();

  const maxTime = 120;
  const pct = Math.min(100, (seconds / maxTime) * 100);
  const radius = 28;
  const circumference = 2 * Math.PI * radius;
  const dashOffset = circumference - (pct / 100) * circumference;

  const isUrgent = seconds > 0 && seconds <= 10;
  const isWarning = seconds > 10 && seconds <= 30;

  const ringColor = isUrgent
    ? theme.palette.error.main
    : isWarning
      ? theme.palette.warning.main
      : theme.palette.primary.main;

  const formatTime = (s) => {
    const min = String(Math.floor(s / 60)).padStart(2, "0");
    const sec = String(s % 60).padStart(2, "0");
    return `${min}:${sec}`;
  };

  if (seconds === 0) {
    return (
      <Box sx={{
        p: 1.5, borderRadius: 2, textAlign: "center",
        backgroundColor: alpha(theme.palette.error.main, 0.12),
        border: `1px solid ${alpha(theme.palette.error.main, 0.2)}`,
      }}>
        <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.error.main }}>
          Time's up! Mantri failed to guess.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{
      display: "flex", alignItems: "center", gap: 1.5, p: 1.5,
      borderRadius: 2,
      backgroundColor: alpha(ringColor, 0.06),
      border: `1px solid ${alpha(ringColor, 0.15)}`,
      animation: isUrgent ? "pulseGlow 1s ease-in-out infinite" : "none",
    }}>
      {/* Circular ring */}
      <Box sx={{ position: "relative", width: 64, height: 64, flexShrink: 0 }}>
        <svg width="64" height="64" viewBox="0 0 64 64" style={{ transform: "rotate(-90deg)" }}>
          <circle
            cx="32" cy="32" r={radius}
            fill="none"
            stroke={alpha(ringColor, 0.15)}
            strokeWidth="4"
          />
          <circle
            cx="32" cy="32" r={radius}
            fill="none"
            stroke={ringColor}
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
            className="timer-ring"
          />
        </svg>
        <Box sx={{
          position: "absolute", inset: 0,
          display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          <Typography variant="body2" sx={{ fontWeight: 800, fontSize: "0.85rem", color: ringColor }}>
            {formatTime(seconds)}
          </Typography>
        </Box>
      </Box>

      {/* Message */}
      <Typography variant="body2" sx={{ fontWeight: 600, fontSize: "0.8rem", color: theme.palette.text.primary }}>
        {message}
      </Typography>
    </Box>
  );
};

export default CountdownTimer;
